<template>
  <transition-group name="list-movies" class="row justify-content-center" mode="out-in">
    <movie v-for="movie in movies" :movie="movie" :type="type" :key="movie.id"></movie>
  </transition-group>
</template>

<script>
import Movie from './Movie';

export default {
  props: ['data'],
  components: { Movie },
  computed: {
    movies() {
      return this.data.movies;
    },
    type() {
      return this.data.type;
    },
  },
};
</script>

<style lang="scss" scoped>
  div {
    transition: all 0.5s;
  }

  .list-movies-enter, .list-movies-leave-to {
    opacity: 0;
    transform: scale(0.8);
  }

  .list-movies-leave-to {
    opacity: 0;
    transform: scale(0.8);
    transition: all 0.2s;
  }

  .list-movies-leave-active {
    position: absolute;
  }
</style>
